import { gql } from '@apollo/client';
import { apolloMutation } from '../apollo';
import { QueryParamKeys } from '../constants/query-params';
import { getQueryParam } from '../helpers/params/params';
import { isSupportedLanguage, SupportedLanguage } from '../helpers/language/language.helper';

export const REPORT_LANGUAGE_TOGGLED = gql`
  mutation ReportLanguageToggled($input: ReportLanguageToggledInput!) {
    reportLanguageToggled(input: $input) {
      reportLanguageToggledErrors {
        __typename
        ... on FatalError {
          message
        }
      }
    }
  }
`;

// The edge caps page at 100 characters and rejects the whole call above it, which would lose the count.
const MAX_PAGE_LENGTH = 100;

const languageService = {
  /**
   * Tells the edge the customer toggled the language, so toggles can be counted (OR-3415). Segment
   * already gets the same toggle as 'Language Toggled', but Segment does not reach Grafana.
   *
   * Fire and forget: nothing waits on it and a failure is dropped, so reporting can never slow down
   * or undo the toggle itself. The response carries nothing the toggle needs; an empty errors array
   * means the edge counted it.
   *
   * `from` and `to` are a `LanguageCode` enum on the edge, so a toggle whose starting language is
   * not known (i18next before init) is not reported rather than sent with a value the edge rejects.
   */
  reportLanguageToggled(from: string | undefined, to: SupportedLanguage, page: string | null | undefined): void {
    if (!isSupportedLanguage(from)) return;
    apolloMutation(REPORT_LANGUAGE_TOGGLED, {
      input: {
        from,
        to,
        page: page ? page.slice(0, MAX_PAGE_LENGTH) : undefined,
        orderId: getQueryParam(QueryParamKeys.OrderId) ?? undefined,
      },
    }).catch(() => undefined);
  },
};

export default languageService;
